import * as LOGOS from "../assets/icons";

export const AGGREGATOR_TYPE: any = {
  swiggy: {
    id: "swiggy",
    logo: LOGOS.logo_swiggy,
    label: "Swiggy",
  },
  zomato: {
    id: "zomato",
    logo: LOGOS.logo_zomato,
    label: "Zomato",
  },
  webhook: {
    id: "webhook",
    logo: LOGOS.logo_webhook,
    label: "Webhook",
  },
  rista: {
    id: "rista",
    logo: LOGOS.logo_rista,
    label: "Rista",
  },
  // amazon: {
  //   id: "amazon",
  //   logo: LOGOS.logo_amazon,
  // },
  amazonfood: {
    id: "amazonfood",
    logo: LOGOS.logo_amazon,
    label: "Amazon Food",
  },
  limetray: {
    id: "limetray",
    logo: LOGOS.logo_limetray,
    label: "Limetray",
  },
  urbanpiper: {
    id: "urbanpiper",
    logo: LOGOS.logo_urbanpiper,
    label: "Urbanpiper",
  },
};

// id comes from BE. and needs to be sent as it is
export const WEBHOOK_SOURCE_TYPE: any = {
  website: {
    key: "website",
    id: "website",
    label: "Website",
  },
  yellowmessenger: {
    key: "yellowmessenger",
    id: "yellowmessenger",
    label: "Yellow Messenger",
  },
  dotpe: {
    key: "dotpe",
    id: "dotpe",
    label: "DotPe",
  },
  dotpedelivery: {
    key: "dotpedelivery",
    id: "DotPeDelivery",
    label: "DotPe Delivery",
  },
  dotpepickup: {
    key: "dotpepickup",
    id: "DotPePickup",
    label: "DotPe Pickup",
  },
  "dotpedine-in": {
    key: "dotpedine-in",
    id: "DotPeDine-in",
    label: "DotPe Dine-in",
  },
  magicpin: {
    key: "magicpin",
    id: "magicpin",
    label: "Magicpin",
  },
  thrive: {
    key: "thrive",
    id: "thrive",
    label: "Thrive",
  },
  ownly: {
    key: "ownly",
    id: "ownly",
    label: "Ownly",
  },
  others: {
    key: "others",
    id: "others",
    label: "Others",
  },
};

/**
 * Aggregators for which Reason is NOT mandatory when turning off outlet status.
 */
export const AGGREGATORS_WITHOUT_MANDATORY_REASON: string[] = [
  "ownly",
];

export function isReasonMandatoryForOutlet(outletData: {
  type?: string;
  webhookSourceType?: string;
}): boolean {
  const type = outletData?.type ?? "";
  const webhookSource = outletData?.webhookSourceType ?? "";
  if (
    AGGREGATORS_WITHOUT_MANDATORY_REASON.includes(type) ||
    AGGREGATORS_WITHOUT_MANDATORY_REASON.includes(webhookSource)
  )
    return false;
  return true;
}

export const AGGREGATOR_FEATURES_MAP: any = {
  activity_log: {
    id: "activity_log",
    text: "Activity Log",
  },
  outlet_toggle: {
    id: "outlet_toggle",
    text: "Outlet On/ Off",
  },
  outlet_status: {
    id: "outlet_status",
  },
  refresh_cta: {
    id: "refresh_cta",
  },
  help_centre: {
    id: "help_centre",
    text: "Help Centre",
  },
  health_hub_cta_payload: {
    id: "health_hub_cta_payload",
  },
  outlet_logistic_status: {
    id: "outlet_logistic_status",
    text: "Outlet Logistics Status",
  },
  surge_on_delivery: {
    id: "surge_on_delivery",
    text: "Surge On Delivery",
  },
  self_delivery_charge: {
    id: "self_delivery_charge",
    text: "Self Delivery Charge",
  },
  delivery_timings: {
    id: "delivery_timings",
    text: "Delivery Timings",
  },
  self_delivery_timings: {
    id: "self_delivery_timings",
    text: "Self Delivery Timing",
  },
  outlet_takeaway_status: {
    id: "outlet_takeaway_status",
    text: "Outlet Takeaway Status",
  },
  takeaway_timings: {
    id: "takeaway_timings",
    text: "Takeaway Timings",
  },
  edit_configuration: {
    id: "edit_configuration",
    text: "Edit Configuration",
  },
};

export const AGGREGATOR_AVAILABLE_FEATURES_MAP: any = {
  swiggy: [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_toggle.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.refresh_cta.id,
    AGGREGATOR_FEATURES_MAP.help_centre.id,
    // AGGREGATOR_FEATURES_MAP.health_hub_cta_payload.id,
    AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  ],
  zomato: [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_toggle.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.refresh_cta.id,
    AGGREGATOR_FEATURES_MAP.help_centre.id,
    AGGREGATOR_FEATURES_MAP.outlet_logistic_status.id,
    // AGGREGATOR_FEATURES_MAP.surge_on_delivery.id,
    AGGREGATOR_FEATURES_MAP.self_delivery_charge.id,
    AGGREGATOR_FEATURES_MAP.delivery_timings.id,
    AGGREGATOR_FEATURES_MAP.self_delivery_timings.id,
    // AGGREGATOR_FEATURES_MAP.outlet_takeaway_status.id,
    // AGGREGATOR_FEATURES_MAP.takeaway_timings.id,
    AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  ],
  webhook_first_type: [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_toggle.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  ],
  webhook_second_type: [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_toggle.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.refresh_cta.id,
    AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  ],
  rista: [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_toggle.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.refresh_cta.id,
    AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  ],
  // amazon: [
  //   AGGREGATOR_FEATURES_MAP.activity_log.id,
  //   AGGREGATOR_FEATURES_MAP.outlet_status.id,
  //   AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  // ],
  amazonfood: [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  ],
  limetray: [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  ],
  urbanpiper: [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.edit_configuration.id,
  ],
  ownly: [
    AGGREGATOR_FEATURES_MAP.outlet_toggle.id,
  ]
};

// Types of activities on outlets
export const OUTLET_ACTIVITY_TYPES: any = {
  OUTLET_STATUS: "Outlet Status Update",
  SYNC: "Menu Sync",
  SELF_DELIVERY_CHARGE: "Self Delivery Charge",
  HEALTH_HUB_SYNC: "Health Hub Sync",
};

// Action types to be sent in action API with key "action"
export const AGGREGATOR_ACTION_TYPES = {
  toggle_outlet_status: "TOGGLE_OUTLET_STATUS",
  get_outlet_status: "GET_OUTLET_STATUS",
  get_outlet_delivery_status: "GET_OUTLET_DELIVERY_STATUS",
  get_help_centre_link: "GET_HELP_URL",
  get_self_delivery_charge: "GET_SELF_DELIVERY_CHARGE",
  update_self_delivery_charge: "UPDATE_SELF_DELIVERY_CHARGE",
  get_outlet_logistic_status: "GET_DELIVERY_STATUS",
  update_outlet_logistic_status: "UPDATE_DELIVERY_STATUS",
  get_delivery_timings: "GET_DELIVERY_TIMINGS",
  update_delivery_timings: "UPDATE_DELIVERY_TIMINGS",
  get_delivery_surge: "GET_DELIVERY_SURGE",
  get_self_delivery_timings: "GET_SELF_DELIVERY_TIMINGS",
  update_self_delivery_timings: "UPDATE_SELF_DELIVERY_TIMINGS",
  get_takaway_status: "GET_TAKEAWAY_STATUS",
  get_takeaway_timings: "GET_TAKEAWAY_TIMINGS",
};

// Action types to be sent in bulk action API with key "action"
export const AGGREGATOR_BULK_ACTION_TYPES = {
  bulk_outlet_status_update: "aggregator.outlet.status",
  bulk_menu_sync: "aggregator.menu.sync",
};

export const OUTLET_BULK_ACTIONS: any = {
  bulk_menu_sync: {
    type: "bulk_menu_sync",
    label: "Bulk Menu Sync",
    confirmationCtaText: "Confirm Menu Sync",
    actionBarText: "Click & Select the outlet card to sync menu",
    branchChannelTableDescription:
      "Please check branches and channels before initiating menu sync.",
  },
  bulk_outlet_status_update: {
    type: "bulk_outlet_status_update",
    label: "Bulk Outlet ON/ OFF",
    confirmationCtaText: "Update Outlet Status",
    actionBarText: "Click & Select the outlet card for bulk outlet ON/ OFF",
    branchChannelTableDescription:
      "Please check branches and channels before initiating outlet status update.",
  },
};

export const AGGREGATOR_CONFIG_MADATORY_FIELDS_MAP: any = {
  swiggy: {
    id: { key: "id", type: "string" },
    extId: { key: "extId", type: "string" },
    extURL: { key: "extURL", type: "string" },
    channelDefId: { key: "channelDefId", type: "string" },
    brid: { key: "brid", type: "string" },
  },
  zomato: {
    id: { key: "id", type: "string" },
    extId: { key: "extId", type: "string" },
    extURL: { key: "extURL", type: "string" },
    channelDefId: { key: "channelDefId", type: "string" },
    brid: { key: "brid", type: "string" },
  },
  webhook: {
    id: { key: "id", type: "string" },
    channelDefId: { key: "channelDefId", type: "string" },
    brid: { key: "brid", type: "string" },
    webhookId: { key: "webhookId", type: "string" },
    webhookSourceType: { key: "webhookSourceType", type: "string" },
  },
  rista: {
    id: { key: "id", type: "string" },
    channelDefId: { key: "channelDefId", type: "string" },
    brid: { key: "brid", type: "string" },
    "preferences.paymentInfo": {
      key: "preferences.paymentInfo",
      type: "array",
    },
    "preferences.deliveryModes": {
      key: "preferences.deliveryModes",
      type: "array",
    },
  },
  amazonfood: {
    id: { key: "id", type: "string" },
    extId: { key: "extId", type: "string" },
    extURL: { key: "extURL", type: "string" },
    channelDefId: { key: "channelDefId", type: "string" },
    brid: { key: "brid", type: "string" },
  },
  limetray: {
    id: { key: "id", type: "string" },
    channelDefId: { key: "channelDefId", type: "string" },
    brid: { key: "brid", type: "string" },
  },
  urbanpiper: {
    id: { key: "id", type: "string" },
    brid: { key: "brid", type: "string" },
    apiKey: { key: "apiKey", type: "string" },
  },
};

export const OUTLET_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  ONLINE: "online",
  OFFLINE: "offline",
};